/**
 * Number patterns for generated identifiers (admission numbers, receipts, ...).
 *
 * Tokens: {YYYY} {YY} {MM} {DD} and the required {SEQ:n} (zero-padded sequence, n = 1..10).
 * Everything else must be letters, digits, "-", "_" or "/".
 * Example: "ADM-{YYYY}-{SEQ:5}" + seq 42 on 2026-04-01 → "ADM-2026-00042".
 */
const TOKEN = /\{(YYYY|YY|MM|DD|SEQ:(\d{1,2}))\}/g;
const LITERAL = /^[A-Za-z0-9\-_/]*$/;
export function validateNumberPattern(pattern) {
    if (pattern.length === 0 || pattern.length > 60)
        return 'Pattern must be 1-60 characters';
    let seqTokens = 0;
    let invalidSeq = false;
    const literalsOnly = pattern.replace(TOKEN, (_match, token, width) => {
        if (token.startsWith('SEQ')) {
            seqTokens += 1;
            const n = Number(width);
            if (n < 1 || n > 10)
                invalidSeq = true;
        }
        return '';
    });
    if (invalidSeq)
        return '{SEQ:n} width must be between 1 and 10';
    if (seqTokens !== 1)
        return 'Pattern must contain exactly one {SEQ:n} token';
    if (!LITERAL.test(literalsOnly)) {
        return 'Only letters, digits, "-", "_", "/" and the tokens {YYYY} {YY} {MM} {DD} {SEQ:n} are allowed';
    }
    return null;
}
/** Renders a pattern for a sequence number and date. Throws for an invalid pattern. */
export function formatNumber(pattern, sequence, date = new Date()) {
    const error = validateNumberPattern(pattern);
    if (error)
        throw new Error(error);
    if (!Number.isInteger(sequence) || sequence < 0)
        throw new Error('Sequence must be >= 0');
    const yyyy = String(date.getUTCFullYear()).padStart(4, '0');
    return pattern.replace(TOKEN, (_match, token, width) => {
        switch (token) {
            case 'YYYY':
                return yyyy;
            case 'YY':
                return yyyy.slice(-2);
            case 'MM':
                return String(date.getUTCMonth() + 1).padStart(2, '0');
            case 'DD':
                return String(date.getUTCDate()).padStart(2, '0');
            default:
                return String(sequence).padStart(Number(width), '0');
        }
    });
}
//# sourceMappingURL=number-format.js.map